import React from "react";
import { ChevronDown } from "lucide-react";
import "./FilterDropdown.css";

const FilterDropdown = ({ label, value, onChange, options }) => {
    return (
        <div className="filter-section">
            <label className="filter-label">{label}</label>

            <div className="fd-wrapper">
                <select value={value} onChange={onChange} className="fd-select">
                    <option value="">Select {label}</option>
                    {options.map((opt, index) => (
                        <option key={index} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>

                <ChevronDown className="fd-icon" />
            </div>
        </div>
    );
};

export default FilterDropdown;
